import { strCode } from "../../../consts";
import { t } from "../../../services";

const getReportData = (data, metricsConfig) => {
  const result = [];

  data.forEach((item) => {
    const reportData = {};
    let total = 0;

    Object.keys(item.metrics).forEach((metric) => {
      const metricConfig = metricsConfig[metric];

      const metricName = t(metricConfig?.name) ?? metric;
      const value = item.metrics[metric] ?? 0;

      reportData[metricName] = value;
      total += value;
    });

    reportData[t(strCode.TOTAL_TITLE)] = total;
    result.push(reportData);
  });

  return result;
};

export const reportUtils = {
  getReportData
};
